import { render, staticRenderFns } from "./GroupPersonCreateModal.vue?vue&type=template&id=35c97327&"
import script from "./GroupPersonCreateModal.vue?vue&type=script&lang=js&"
export * from "./GroupPersonCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports